import { useState } from "react";

export default function ProfileForm({ user, onSave, onCancel }) {
  const [form, setForm] = useState({
    firstName: user.firstName,
    lastName: user.lastName,
    phone: user.phone || "",
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function submit() {
    // 👉 ici plus tard : updateProfile(form)
    onSave();
  }

  return (
    <div className="profileBox">
      <h3>Modifier le profil</h3>

      <Input label="Prénom" name="firstName" value={form.firstName} onChange={handleChange} />
      <Input label="Nom" name="lastName" value={form.lastName} onChange={handleChange} />
      <Input label="Téléphone" name="phone" value={form.phone} onChange={handleChange} />

      <div className="formActions">
        <button className="btnPrimary" onClick={submit}>Enregistrer</button>
        <button className="btnGhost" onClick={onCancel}>Annuler</button>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}
